import { render } from "./JobPost.vue?vue&type=template&id=2bb1928d&scoped=true"
import script from "./JobPost.vue?vue&type=script&lang=js"
export * from "./JobPost.vue?vue&type=script&lang=js"

import "./JobPost.vue?vue&type=style&index=0&id=2bb1928d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb1928d"]])

export default __exports__